export const caseStudies = [
  {
    id: 1,
    title: "製造業向けAI在庫最適化システム",
    client: "顧客A",
    category: "AI/機械学習",
    duration: "5ヶ月",
    image: "/logo.png",
    challenge: {
      title: "課題",
      description: "製造ラインにおける在庫管理では、経験や勘に頼った発注と、出荷頻度を考慮しない非効率な倉庫配置のため、年間で約2,000万円の機会損失および保管コストが発生していました。また、手作業によるピッキングが常態化しており、人手不足と相まって誤ピッキングによる納期遅延リスクが高まり、効率改善の停滞が課題となっていました。"
    },
    approach: {
      title: "アプローチ",
      description: "本システムでは、過去の出荷傾向に基づき関連部品の発注数を提案する需要予測AIを導入することで適正在庫の維持を目指し、設置箇所の最適化提案によって無駄な在庫と非効率な配置を解消しました。さらに、Picking-to-Lightシステムをスマートフォンと連携させることで、ピッキング作業の効率と正確性を向上させる仕組みを構築しました。"
    },
    solution: {
      title: "解決",
      description: "在庫管理システム導入の結果、在庫の過剰・不足による機会損失が年間約1,000万円削減され、在庫適正化率が80%に向上しました。ピッキングの動線が最適化されたことで、平均ピッキング時間が従来比で40%短縮され、作業員の身体的負荷が軽減しました。また、誤ピッキング率が1.5%以下に抑えられ、再作業コストが大幅に削減されたため、製造ライン全体の生産性が15%向上しました。"
    },
    results: [
      "年間機会損失 約1,000万円削減",
      "在庫適正化率 80%達成",
      "平均ピッキング時間 40%短縮",
      "誤ピッキング率 1.5%以下",
      "製造ライン生産性 15%向上"
    ],
    technologies: ["Python", "TensorFlow", "React", "AWS Lambda", "DynamoDB"]
  },
  {
    id: 2,
    title: "不動産業界向けAI物件マッチングシステム",
    client: "顧客B",
    category: "AI/機械学習",
    duration: "4ヶ月",
    image: "/logo.png",
    challenge: {
      title: "課題",
      description: "大手不動産仲介会社では、顧客の希望条件だけでは本当に満足する物件を提案できず、成約率が低迷していました。営業担当者の経験と勘に依存した提案では、顧客の潜在的なニーズを見逃し、内見後のミスマッチが頻発。結果として、1件の成約に平均3~4件の内見が必要で、顧客満足度も60%程度に留まっていました。膨大な物件データベースを活用しきれていないことも課題でした。"
    },
    approach: {
      title: "アプローチ",
      description: "顧客の明示的な希望条件に加え、ライフスタイルや価値観、過去の閲覧履歴などを分析するAIマッチングエンジンを開発しました。自然言語処理（NLP）で顧客の曖昧な要望を理解し、協調フィルタリングで類似顧客の成約実績から最適な物件を推薦。さらに、通勤時間、周辺施設、将来の資産価値なども考慮したスコアリングシステムを実装。2週間で動作するプロトタイプを提供し、実際の成約データでモデルを継続的に改善しました。"
    },
    solution: {
      title: "解決",
      description: "AI物件マッチングシステムの導入により、成約までの平均内見回数が4件から2件に削減され、営業効率が大幅に向上しました。成約率は従来比で1.8倍に向上し、顧客満足度は90%を超えました。AIが提案した物件の70%が実際に内見され、そのうち45%が成約という高い精度を実現。営業担当者は物件探しの時間が50%削減され、顧客とのコミュニケーションに注力できるようになりました。"
    },
    results: [
      "平均内見回数 4件→2件に削減",
      "成約率 1.8倍向上",
      "顧客満足度 90%超え",
      "営業時間 50%削減"
    ],
    technologies: ["Python", "scikit-learn", "Natural Language Processing", "React", "FastAPI", "PostgreSQL"]
  },
  {
    id: 3,
    title: "製造業向け生産管理システム統合",
    client: "顧客C",
    category: "業務システム",
    duration: "6ヶ月",
    image: "/logo.png",
    challenge: {
      title: "課題",
      description: "生産管理に使用するツールが多様化していたため、管理が煩雑になっていました。特に、営業担当と現場の連携方法に統一されたルールがなかったため、担当者によって見積もり精度や納期回答の質が変動し、製造実績の確認や管理方法が異なることで年間約3,500万円相当の確認・調整コストが膨らんでいました。また、ブラックボックス化していた生産実態により、収益性の低い案件の見積もりも見過ごされている状況でした。"
    },
    approach: {
      title: "アプローチ",
      description: "工場の生産管理フロー全体をシステム化することで、データ分析に基づいた見積もり金額の最適化を支援しました。具体的には、作業工程ごとに見積もりに対する実際の実績時間・コストを記録し、その傾向を分析することで、見積もり金額の精度や作業効率の改善点を定量的に可視化する仕組みを構築しました。これにより、属人化していた生産・見積もりプロセスを標準化し、営業と現場の共通言語をデータに統一しました。"
    },
    solution: {
      title: "解決",
      description: "このシステム導入の結果、見積もり精度が従来の70%から90%に向上し、収益性の高い受注の確保に成功しました。営業担当者と現場間の確認コストの削減にも成功し、営業担当者は顧客対応に注力できるようになりました。また、実績データに基づき工場の非効率なボトルネックを特定したことで、製造ライン全体の納期遵守率が94%に改善し、全体的な生産リードタイムも20%短縮しました。"
    },
    results: [
      "見積もり精度 70%→90%に向上",
      "確認・調整コスト 年間約1,500万円削減",
      "納期遵守率 94%達成",
      "生産リードタイム 20%短縮"
    ],
    technologies: ["React", "Node.js", "PostgreSQL", "TypeScript", "Docker"]
  }
];
